import { AlertOctagon } from "lucide-react";

export function ManualReviewBanner({ reasons }) {
  return (
    <section className="paper-card overflow-hidden border-destructive/40">
      <div className="flex flex-col gap-0 sm:flex-row">
        <div className="flex items-center gap-3 bg-destructive px-6 py-5 text-destructive-foreground sm:w-72 sm:flex-col sm:items-start sm:justify-center sm:gap-2 sm:py-8">
          <AlertOctagon className="h-6 w-6" />
          <div>
            <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-destructive-foreground/80">
              Status
            </p>
            <p className="font-display text-xl font-medium leading-tight">Manual Review Required</p>
          </div>
        </div>
        <div className="flex-1 px-6 py-5 sm:px-8 sm:py-8">
          <p className="text-sm leading-relaxed text-foreground">
            One or more responses trigger the safeguarding or governance hold. Automated scoring
            has been suspended. Do not act on the categorisation below without a guided review by a
            qualified NDIS consultant.
          </p>
          <ul className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
            {reasons.map((reason) => (
              <li
                key={reason}
                className="flex items-start gap-2 rounded-sm border border-destructive/20 bg-destructive-soft/60 p-3 text-[13px] leading-relaxed text-foreground"
              >
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-destructive" />
                {reason}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
